import { render, staticRenderFns } from "./formFlowCategory.vue?vue&type=template&id=dbc40378&"
import script from "./formFlowCategory.vue?vue&type=script&lang=js&"
export * from "./formFlowCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports